var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-row',[_c('h4',[_vm._v(_vm._s(_vm.$t("match-raw-title")))])]),_c('b-row',[_c('pre',[_vm._v(_vm._s(_vm.match))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }